module.exports = __webpack_public_path__ + "static/img/3.3989bc1c.png";